<template>
  <div class="ui middle center aligned grid" id="login">
    <div class="column">
      <h2 class="ui teal image header">
        <div class="content">
          用户注册
        </div>
      </h2>
      <form class="ui large form" :class="{error: error}">
        <div class="ui stacked segment">
          <div class="required field">
            <div class="ui left icon input">
              <i class="user icon"></i>
              <input type="text" name="username" v-model="account.username" placeholder="用户账号">
            </div>
          </div>
          <div class="required field">
            <div class="ui left icon input">
              <i class="mail icon"></i>
              <input type="text" name="email" v-model="account.email" placeholder="用户邮箱">
            </div>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="registered icon"></i>
              <input type="text" name="invitation" v-model="account.invitationCode" placeholder="邀请码">
            </div>
          </div>
          <div class="required field">
            <div class="ui left icon input">
              <i class="unlock icon"></i>
              <input type="password" name="password" v-model="account.password" placeholder="用户密码">
            </div>
          </div>
          <div class="required field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input type="password" name="confirm" v-model="account.confirm" placeholder="确认密码">
            </div>
          </div>
          <div class="ui fluid large teal submit button" @click="register">注册</div>
          <div class="ui error message">
            {{ error }}
          </div>
        </div>
      </form>
      <div class="extra content">
        已有帐号？
        <router-link to="/login">登录</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '../../services/Auth'
import storage from '@/services/StorageService'

export default {
  name: 'register-view',
  data () {
    return {
      error: '',
      account: {
        username: '',
        email: '',
        invitationCode: '',
        password: '',
        confirm: '',
      }
    }
  },
  methods: {
    register () {
      this.error = ''
      if (this.account.username.length < 6) {
        this.error = '账号长度至少6位'
        return
      }
      if (this.account.email.length < 6) {
        this.error = '邮箱长度至少6位'
        return
      }
      if (this.account.password.length < 8) {
        this.error = '密码长度至少8位'
        return
      }
      if (this.account.password !== this.account.confirm) {
        this.error = '密码不匹配'
        return
      }
      auth.register(this.account).then(({ data }) => {
        storage.setItem('username', this.account.username)
        this.$toasted.success('注册成功')
        this.$router.push('/login')
      }, (err) => {
        this.error = err.message
      })
      return false
    }
  }
}
</script>

<style>
.column {
  max-width: 465px;
}

#login {
  margin-top: 200px;
}
</style>
